import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useUsersApi } from "../../http/users/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteUserDialogProps = {
  userId: string;
  onClose: () => void;
};

const DeleteUserDialog: FC<DeleteUserDialogProps> = ({ onClose, userId }) => {
  const i18n = useI18n();
  const usersApi = useUsersApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.users.delete}
      isSubmitting={isSubmitting}
      actions={[
        { title: i18n.t.common.cancel, type: "secondary", onClick: onClose },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            setIsSubmitting(true);
            usersApi
              .deleteAdminUser(userId)
              .then(() => {
                dispatch(showSuccessNotification(i18n.t));
                onClose();
              })
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.users.questions.delete}
    </ModalDialog>
  );
};

export default DeleteUserDialog;
